import List from 'src/storage/list';

class LocationManagersModel extends List {
  id = 'LocationManagersModel';
  defaultState = () => ({
    current: 'recent'
  });

  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams(loadMore) {
    const req = {
      skip: 0,
      limit: this.listLimit
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

const model = new LocationManagersModel();
export default model;
